import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up-arrow",
  "use": "icon-up-arrow-usage",
  "viewBox": "0 0 2204 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2204 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-up-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M1462.04861385 748.00721377L1102.08005473 363.88457058 744.13106837 748.00721377H596.62151095l444.30589598-472.01442754h123.92095353l442.44789 472.01442755h-145.40920245z\" fill=\"#828181\" p-id=\"4446\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol